import {
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React, { useEffect, useState } from "react";
import { ReactComponent as InterestsIcon } from "./icons/interests.svg";
import { ReactComponent as SkillsIcon } from "./icons/skill.svg";
import { ReactComponent as StylesIcon } from "./icons/styles.svg";
import { InterestsPie } from "./InterestsPie";
import { SkillsList } from "./SkillsList";
import { StylesRadar } from "./StylesRadar";
import CloseIcon from "@mui/icons-material/Close";

const matchTypes = [
  {
    type: "skills",
    title: "Matching Skills",
    buttontitle: "Skill Match",
    subTitle: "Scroll down to see all your skills that match the current job",
    view: (props) => <SkillsList {...props} />,
    icon: (props) => <SkillsIcon {...props} />,
  },
  {
    type: "interests",
    title: "Matching Interests",
    buttontitle: "Interest Match",
    subTitle: "All your interests that match the current job",
    view: (props) => <InterestsPie {...props} />,
    icon: (props) => <InterestsIcon {...props} />,
  },
  {
    type: "styles",
    title: "Matching Styles",
    buttontitle: "Styles Match",
    subTitle: "All your styles that match the current job",
    view: ({ job, candidate, ...props }) => {
      const styles_scale = 5
      const radarData = candidate.stylesGraphData ? candidate.stylesGraphData.map((item) => {
        return {
          label: item.name,
          id: item.name,
          You: item.Candidate,
          Vacancy: Math.round(((job.ONET_styles ? job.ONET_styles[item.name] : 0) / styles_scale) * 100, 2),
        }
      }) : [];
      return <StylesRadar {...props} data={radarData} />;
    },
    icon: (props) => <StylesIcon {...props} />,
  },
];

export const MatchBreakdown = ({ defaultType = "skills", onClose, job, candidate }) => {
    const [currentViewIndex, setCurrentViewIndex] = useState(
      matchTypes.findIndex(({ type }) => type === defaultType)
    );
    const currentView = matchTypes[currentViewIndex];
    const getNextIndex = (index) => (index === 2 ? 0 : index + 1);
    const getPreviousIndex = (index) => (index === 0 ? 2 : index - 1);

    useEffect(() => {
      setCurrentViewIndex(
        matchTypes.findIndex(({ type }) => type === defaultType)
      );
    }, [defaultType]);

    const [right, setRight] = useState("-1000px");

    useEffect(() => {
      setTimeout(() => {
        setRight("0px");
      }, 100);
    }, []);

    return (
      <div style={{
        right: right,
        width: { xs: "100vw", sm: 520 },
        height: "100%",
        position: "absolute",
        transition: "all 0.5s"
      }}>
        <Paper style={{ paddingTop: 20, borderRadius: 0, height: "100%", position: 'relative' }}>
          <div>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <IconButton onClick={() => {
                  setRight("-1000px");
                  setTimeout(() => {
                    onClose();
                  }, 300);
                }} className="close-button" sx={{ mr: 1.25 }}>
                  <CloseIcon sx={{ color: "black" }} />
                </IconButton>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item zeroMinWidth>
              {currentView.icon({ style: { height: 40, width: 40, marginLeft: 18 } })}
            </Grid>
            <Grid item sx={{ ml: "1em" }} xs zeroMinWidth>
              <Typography variant="h5" sx={{ fontSize: 18, fontWeight: 600, color: "#202A3E" }}>
                {currentView.title}
              </Typography>
              <Typography variant="body1" sx={{ color: "#5A6375", fontSize: 10 }}>
                {currentView.subTitle}
              </Typography>
            </Grid>
          </Grid>

          <Divider sx={{ backgroundColor: "#F5F6F7" }} />
          <div style={{ margin: 20, height: "80%" }}>
            {currentView.view({ job, candidate })}
          </div>

          <div style={{ padding: 18, background: "#F8F9FA", position: "absolute", bottom: 0, width: "100%" }}>
            <Grid container justifyContent="space-between">
              <Grid item xs="auto">
                <Button
                  className="previous-button"
                  variant="outlined"
                  color="default"
                  size="small"
                  onClick={() =>
                    setCurrentViewIndex(getPreviousIndex(currentViewIndex))
                  }
                  startIcon={<ChevronLeftIcon />}
                  sx={{ color: "#5B657D", height: 25, fontSize: 10 }}
                >
                  {matchTypes[getPreviousIndex(currentViewIndex)].buttontitle}
                </Button>
              </Grid>
              <Grid item xs="auto" style={{ marginRight: 35 }}>
                <Button
                  className="next-button"
                  variant="outlined"
                  color="default"
                  size="small"
                  endIcon={<ChevronRightIcon />}
                  onClick={() =>
                    setCurrentViewIndex(getNextIndex(currentViewIndex))
                  }
                  sx={{ color: "#5B657D", height: 25, fontSize: 10 }}
                >
                  {matchTypes[getNextIndex(currentViewIndex)].buttontitle}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
  );
};